<template>
  <div id="app" class="app">
    <spinner action="FETCH_CONFIG">
      <router-view />
    </spinner>
    <div class="footer">
      <div class="footer-text">
        2019-2024 Maciej | Native flow
      </div>
      <connection-status-badge />
    </div>
  </div>
</template>
<script>
import { SingleActions } from '@/shared/Actions'
import Spinner from '@/components/Spinner'
import ConnectionStatusBadge from '@/components/ConnectionStatusBadge'

export default {
  name: 'App',
  components: { ConnectionStatusBadge, Spinner },
  watch: {
    '$route.name': function(val) {
      document.title = val || 'Zapisy'
    }
  },
  created() {
    this.$store.dispatch('countUserFingerPrint')
    this.$store.dispatch(SingleActions.FETCH_CONFIG)
    document.title = this.$route.name || 'Zapisy'
  }
}
</script>
